<div id="cl-wrapper" class="login-container login-theme">

  <div class="block-flat" style="display: block; margin-left: auto;
  margin-right: auto; width: 70%; border-radius: 4px;">
    <div class="header">
      <h3 class="text-center">
        <img alt="logo" class="img-responsive logo-img" style="display: block; margin-left: auto;
        margin-right: auto; width: 25%;">
      </h3>
    </div>



    <div class="row" *ngIf="form">
      <div class="col-md-12">
        <form [formGroup]="form" class="form-horizontal">

          <div class="alert alert-danger" *ngIf="formAllErrors.length > 0">
            <ul [innerHtml]="formAllErrors | safeHtml"></ul>
          </div>

          <div class="col-md-12">

            <br>
            <h2>Registo Fornecedor</h2>
            <br>


            <!-- Company -->
            <div class="form-group">
              <div class="col-md-6" *ngIf="form.get('Company')">
                <mat-form-field class="full-width">
                  <mat-label>{{'COMPANY'|translate}}</mat-label>
                  <mat-select formControlName="Company"
                    (change)="onChangeCompany($event.target)">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let c of companies" [value]="c.ID">{{
                      c.Name }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="formErrors.Company" class="font75per"> {{ formErrors.Company }}
                </mat-error>
              </div>
            </div>

            <div class="panel panel-default" *ngIf="form.get('Company').value">
              <div class="form-group">

                <!-- Form completo -->
                <div class="col-md-12">
                  <!-- Primeiro Painel -->
                  <div class="col-md-12">
                    <!-- Nome -->
                    <div class="form-group" *ngIf="form.get('Name')">
                      <div class="col-md-12">
                        <mat-form-field class="full-width">
                          <mat-label>{{'NAME'|translate}}</mat-label>
                          <input type="text" matInput formControlName="Name" matInput>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.Name" class="font75per"> {{ formErrors.Name }}
                        </mat-error>
                      </div>
                    </div>

                    <!-- Morada 
                    <div class="form-group" *ngIf="form.get('Adress')">
                      <div class="col-md-12">
                        <mat-form-field class="full-width">
                          <input type="text" matInput formControlName="Adress" matInput
                            placeholder="{{'ADDRESS'|translate}}">
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.Adress" class="font75per"> {{ formErrors.Adress }}
                        </mat-error>
                      </div>
                    </div>-->


                    <div class="form-group">
                      <!-- Rua -->
                      <div class="col-md-6" *ngIf="form.get('Street')">
                        <mat-form-field class="full-width">
                          <mat-label>{{'STREET'|translate}}</mat-label>
                          <input type="text" matInput formControlName="Street" matInput>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.Street" class="font75per"> {{ formErrors.Street }}
                        </mat-error>
                      </div>

                      <!-- Nº Porta -->
                      <div class="col-md-6" *ngIf="form.get('DoorNumber')">
                        <mat-form-field class="full-width">
                          <mat-label>{{'DOOR_NUMBER'|translate}}</mat-label>
                          <input type="text" matInput formControlName="DoorNumber" matInput>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.DoorNumber" class="font75per"> {{ formErrors.DoorNumber }}
                        </mat-error>
                      </div>
                    </div>

                    <div class="form-group">
                      <!-- Código Postal -->
                      <div class="col-md-6" *ngIf="form.get('PostalCode')">
                        <mat-form-field class="full-width">
                          <mat-label>{{'POSTAL_CODE'|translate}}</mat-label>
                          <input type="text" matInput formControlName="PostalCode" matInput>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.PostalCode" class="font75per"> {{ formErrors.PostalCode }}
                        </mat-error>
                      </div>

                      <!-- Localidade -->
                      <div class="col-md-6" *ngIf="form.get('Location')">
                        <mat-form-field class="full-width">
                          <mat-label>{{'CITY'|translate}}</mat-label>
                          <input type="text" matInput formControlName="Location" matInput>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.Location" class="font75per"> {{ formErrors.Location }}
                        </mat-error>
                      </div>
                    </div>

                    <!-- Pais -->
                    <div class="form-group" *ngIf="form.get('Country')">
                      <div class="col-md-3">
                        <mat-form-field class="full-width">
                          <mat-label>{{'COUNTRY'|translate}}</mat-label>
                          <mat-select formControlName="Country">
                            <mat-option></mat-option>
                            <mat-option *ngFor="let country of countries" [value]="country.Code">{{
                              country.Name }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.Country" class="font75per"> {{ formErrors.Country }}
                        </mat-error>
                      </div>
                    </div>

                    <!-- Telefone -->
                    <div class="form-group" *ngIf="form.get('MobilePhone')">
                      <div class="col-md-3">
                        <mat-form-field class="full-width">
                          <mat-label>{{'PHONE'|translate}}</mat-label>
                          <input type="text" matInput formControlName="MobilePhone" matInput>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.MobilePhone" class="font75per"> {{ formErrors.MobilePhone }}
                        </mat-error>
                      </div>
                    </div>


                    <!-- Email (Faturas) -->
                    <div class="form-group" *ngIf="form.get('Email')">
                      <div class="col-md-6">
                        <mat-form-field class="full-width">
                          <mat-label>{{'EMAIL'|translate}}</mat-label>
                          <input type="text" matInput formControlName="Email" matInput>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.Email" class="font75per"> {{ formErrors.Email }}
                        </mat-error>
                      </div>
                    </div>

                    <!-- Email encomendas -->
                    <div class="form-group" *ngIf="form.get('OrdersEmail')">
                      <div class="col-md-6">
                        <mat-form-field class="full-width">
                          <mat-label>{{'ORDERS_EMAIL'|translate}}</mat-label>
                          <input type="text" matInput formControlName="OrdersEmail" matInput>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.OrdersEmail" class="font75per"> {{ formErrors.OrdersEmail }}
                        </mat-error>
                      </div>
                    </div>

                    <!-- NIF -->
                    <div class="form-group" *ngIf="form.get('Vat')">
                      <div class="col-md-6">
                        <mat-form-field class="full-width">
                          <mat-label>{{'VAT'|translate}}</mat-label>
                          <input type="text" matInput formControlName="Vat" matInput>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.Vat" class="font75per"> {{ formErrors.Vat }}
                        </mat-error>
                      </div>
                    </div>

                    <!-- CAE -->
                    <div class="form-group" *ngIf="form.get('EconomicActivityCode')">
                      <div class="col-md-6">
                        <mat-form-field class="full-width">
                          <mat-label>{{'CAE'|translate}}</mat-label>
                          <mat-select formControlName="EconomicActivityCode"
                            style="text-align: left;">
                            <mat-option></mat-option>
                            <mat-option *ngFor="let cae of caes" [value]="cae.ItemCode">{{cae.ItemName}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-error *ngIf="formErrors.EconomicActivityCode" class="font75per"> {{
                          formErrors.EconomicActivityCode }}
                        </mat-error>
                      </div>
                    </div>
                    
                  </div>

                    <br>

                  <!-- Segundo Painel -->
                  <!-- Dados Bancarios -->
                  <div class="col-md-12">
                    <div class="panel panel-default">
                      <div class="panel-heading clearfix pointer" data-toggle="collapse" aria-expanded="false"
                        data-target="#collPn1">
                        <h5 class="panel-title">
                          <strong>{{'BANK_DATA'|translate}}</strong>
                        </h5>
                      </div>
                      <div id="collPn1" class="panel-body no-horizontal-padding collapse"
                        [ngClass]="{'in': bankDataRadio}">

                        <div class="form-group" *ngIf="form.get('BankCountry')">
                          <div class="col-sm-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'BANK_COUNTRY'|translate}}</mat-label>
                              <mat-select formControlName="BankCountry">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let country of countries" [value]="country.Code">{{
                                  country.Name }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.BankCountry" class="font75per"> {{
                              formErrors.BankCountry }}
                            </mat-error>
                          </div>
                        </div>
                        <!-- Banco Nome -->
                        <div class="form-group" *ngIf="form.get('BankName')">
                          <div class="col-md-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'BANK_NAME'|translate}}</mat-label>
                              <input type="text" matInput formControlName="BankName" matInput>
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.BankName" class="font75per"> {{ formErrors.BankName }}
                            </mat-error>
                          </div>
                        </div>
                        <!-- Banco Morada -->
                        <div class="form-group" *ngIf="form.get('BankAdress')">
                          <div class="col-md-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'BANK_ADRESS'|translate}}</mat-label>
                              <input type="text" matInput formControlName="BankAdress" matInput>
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.BankAdress" class="font75per"> {{ formErrors.BankAdress }}
                            </mat-error>
                          </div>
                        </div>
                        <!-- ControlKey -->
                        <div class="form-group" *ngIf="form.get('ControlKey')">
                          <div class="col-md-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'CONTROL_KEY'|translate}}</mat-label>
                              <input type="text" matInput formControlName="ControlKey" matInput>
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.ControlKey" class="font75per"> {{ formErrors.ControlKey }}
                            </mat-error>
                          </div>
                        </div>
                        <div class="form-group" *ngIf="form.get('Currency')">
                          <div class="col-sm-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'CURRENCY'|translate}}</mat-label>
                              <mat-select formControlName="Currency">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let cur of bankCurrencies" [value]="cur.Code">{{
                                  cur.Name }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.Currency" class="font75per"> {{
                              formErrors.Currency }}
                            </mat-error>
                          </div>
                        </div>

                        <!-- IBAN INPUT -->
                        <div class="form-group" *ngIf="form.get('IBAN')">
                          <div class="col-sm-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'IBAN'|translate}}</mat-label>
                              <input type="text" matInput formControlName="IBAN" matInput
                                style="text-align: left;">
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.IBAN" class="font75per"> {{
                              formErrors.IBAN }}
                            </mat-error>
                          </div>
                          <div class="col-md-3 col-sm-12">
                            <mat-form-field class="allwidth">
                              <mat-label>{{ 'IBAN_START_DATE' | translate}}</mat-label>
                                <input matInput formControlName="IBANFromDate" class="one date-picker">
                                    <i matSuffix class="far fa-calendar-alt bigger-110" *ngIf="form.get('IBAN')"></i>
                            </mat-form-field>
                          </div>
                        </div>

                        <div class="form-group" *ngIf="form.get('SwiftBic')" >
                          <div class="col-sm-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'SWIFT_BIC'|translate}}</mat-label>
                              <input type="text" matInput formControlName="SwiftBic" matInput>
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.SwiftBic" class="font75per"> {{ formErrors.SwiftBic }}
                            </mat-error>
                          </div>
                        </div>

                        <div class="form-group" *ngIf="form.get('BankKey')">
                          <div class="col-sm-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'BANK_KEY'|translate}}</mat-label>
                              <input type="text" matInput formControlName="BankKey" matInput>
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.BankKey" class="font75per"> {{
                              formErrors.BankKey }}
                            </mat-error>
                          </div>
                        </div>

                        <div class="form-group" *ngIf="form.get('BankAgencyNumber')">
                          <div class="col-sm-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'BANK_BRANCH_N'|translate}}</mat-label>
                              <input type="text" matInput formControlName="BankAgencyNumber" matInput>
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.BankAgencyNumber" class="font75per"> {{
                              formErrors.BankAgencyNumber }}
                            </mat-error>
                          </div>
                        </div>

                        <div class="form-group" *ngIf="form.get('BankAccount')">
                          <div class="col-sm-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'BANK_ACCOUNT'|translate}}</mat-label>
                              <input type="text" matInput formControlName="BankAccount" matInput>
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.BankAccount" class="font75per"> {{
                              formErrors.BankAccount }}
                            </mat-error>
                          </div>
                        </div>

                        <div class="form-group" *ngIf="form.get('Region')">
                          <div class="col-sm-12">
                            <mat-form-field class="full-width">
                              <mat-label>{{'REGION'|translate}}</mat-label>
                              <input type="text" matInput formControlName="Region" matInput>
                            </mat-form-field>
                            <mat-error *ngIf="formErrors.Region" class="font75per"> {{
                              formErrors.BankKey }}
                            </mat-error>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                  </div>

                  <br><br>

                  <!-- Upload Documentos -->

                  <!-- Primeiro Upload -->
                  <div class="form-group" *ngIf="form.get('IbanProof')">
                    <div class="col-md-6">

                      <text-field style="padding-left: 18px;">
                        <i>{{'IBAN_PROOF'|translate}} ({{'REQUIRED'|translate}})</i>
                      </text-field>

                      <div class="col-sm-12">
                        <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
                          (fileOver)="hasBaseDropZoneOver=$event" [uploader]="uploader"
                          class="well my-drop-zone no-margin" (click)="inputFile.click()">
                          {{ 'DROP_AREA_DOCUMENT' | translate }}
                        </div>
                        <input type="file" ng2FileSelect [uploader]="uploader" #inputFile class="hide"
                          (change)="addIbanProofFile($event)" />
                        <!--accept=".tiff,.tif,.jpg"-->
                      </div>

                      <div *ngIf="ibanProofFile" class="col-sm-12">
                        <div class="col-sm-11 col-xs-11">
                          <a class="pointer">
                            <span>{{ibanProofFile.name}}</span>
                          </a>
                        </div>
                        <div class="col-sm-1 col-xs-1 text-right">
                          <button type="button" class="btn btn-sm" (click)="removeIbanProofFile()">
                            <span title="{{'BUTTON.DELETE' | translate}}">
                              <i class="far fa-trash-alt color-danger backwhite"></i>
                            </span>
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>

                  <br>

                  <!-- Segundo Upload -->
                  <div class="form-group" *ngIf="form.get('OtherDocuments')">
                    <div class="col-md-6">

                      <text-field style="padding-left: 18px;">
                        <i>{{'OTHER_DOCUMENTS'|translate}}</i>
                      </text-field>

                      <div class="col-sm-12">
                        <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
                          (fileOver)="hasBaseDropZoneOver=$event" [uploader]="uploader"
                          class="well my-drop-zone no-margin" (click)="inputFile2.click()">
                          {{ 'DROP_AREA_DOCUMENT' | translate }}
                        </div>
                        <input type="file" ng2FileSelect [uploader]="uploader" #inputFile2 class="hide"
                          (change)="addOtherDocumentFile($event)" />
                        <!--accept=".tiff,.tif,.jpg"-->
                      </div>

                      <div *ngIf="otherDocumentFile" class="col-sm-12">
                        <div class="col-sm-11 col-xs-11">
                          <a class="pointer">
                            <span>{{otherDocumentFile.name}}</span>
                          </a>
                        </div>
                        <div class="col-sm-1 col-xs-1 text-right">
                          <button type="button" class="btn btn-sm" (click)="removeOtherDocumentFile()">
                            <span title="{{'BUTTON.DELETE' | translate}}">
                              <i class="far fa-trash-alt color-danger backwhite"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                      <div class="col-sm-11 col-xs-11">
                        <mat-error *ngIf="formErrors.OtherDocuments" class="font75per">{{formErrors.OtherDocuments}}
                        </mat-error>
                      </div>
                    </div>
                  </div>
                  <br>
                  <div class="col-md-12" style="align-content: center;" *ngIf="form.get('AcceptRules')">
                    <mat-checkbox formControlName="AcceptRules" (cdkObserveContent)="_onContentChanges()"
                      style="align-content: center; text-align: center;">
                      {{'ACCEPT_RULES_TEXT'|translate}}
                    </mat-checkbox>
                  </div>

                  <div class="col-md-12" style="align-content: center;">
                    <button type="submit" class="btn btn-primary" title="{{'SUBMIT' | translate}}" [disabled]="false"
                      (click)="onSubmit()">
                      <i class="fas fa-check"></i>&nbsp;{{'SUBMIT' | translate}}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="form-group margin-bottom-30">
      <div class="col-sm-12" style="padding-bottom: 25px;">
        <button type="button" class="btn pull-left no-margin-left margin-top-10" title="{{'LOGIN' | translate}}"
          [routerLink]="['/login']">
          <i class="fas fa-arrow-left"></i>&nbsp;{{'LOGIN' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>